exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-11222597] :last-child {\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.actions[data-v-11222597] {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  display: none;\n}\n.card:hover .actions[data-v-11222597] {\n  display: block;\n}", ""]);

// exports
